module.exports = __webpack_public_path__ + "img/Selina@2x.d181f6fe.png";